import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import { userIdDataApi } from '../request/api';
import store from '../store';
import Watermark from '../utils/watermark';
const originalReplace = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const backDoor =
  process.env.NODE_ENV === 'production'
    ? []
    : [
        //登录
        {
          path: '/soa',
          name: 'soa',
          component: () => import('../views/soa.vue')
        }
      ];

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/resume',
    name: 'resume',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/resumedetail.vue'),
    meta: {
      title: '我的简历',
      index: 1
    }
  },
  {
    path: '/employees',
    name: 'employees',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/employees.vue')
  },
  {
    name: 'address',
    path: '/address',
    component: () => import('../views/messagechange/address.vue')
  },

  {
    path: '/prove',
    name: 'prove',
    component: () => import('../views/prove.vue')
  },

  {
    path: '/employment',
    name: 'employment',
    component: () => import('../components/prove/employment.vue')
  },
  {
    path: '/income',
    name: 'income',
    component: () => import('../components/prove/income.vue')
  },
  {
    path: '/residence',
    name: 'residence',
    component: () => import('../components/prove/residence.vue')
  },

  {
    path: '/myincome',
    name: 'myincome',
    component: () => import('../views/myincome.vue')
  },
  {
    path: '/myincomeChange',
    name: 'myincomeChange',
    component: () => import('../views/myincomeChange.vue')
  },
  {
    path: '/incomedetail',
    //path: '/incomedetail/:id',
    name: 'incomedetail',
    component: () => import('../views/incomedetail.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/changepwd',
    name: 'changepwd',
    component: () => import('../components/changepwd/changepwd.vue')
  },

  {
    path: '/myattend',
    name: 'myattend',
    component: () => import('../views/myattend.vue')
  },
  {
    path: '/myattendPc',
    name: 'myattendPc',
    component: () => import('../views/myattendPc.vue')
  },
  {
    path: '/performanceResult',
    name: 'performanceResult',
    component: () => import('../views/performanceResult.vue')
  },
  {
    path: '/performanceResultPc',
    name: 'performanceResultPc',
    component: () => import('../views/performanceResultPc.vue')
  },
  {
    path: '/hrwork',
    name: 'hrwork',
    component: () => import('../views/hrwork.vue')
  },

  {
    path: '/homemsg',
    name: 'homemsg',
    component: () => import('../views/messagechange/homemsg.vue')
  },
  {
    path: '/contactinfo',
    name: 'contactinfo',
    component: () => import('../views/messagechange/contactinfo.vue')
  },
  {
    path: '/bankinfo',
    name: 'bankinfo',
    component: () => import('../views/messagechange/bankinfo.vue')
  },
  {
    path: '/canceldata',
    name: 'canceldata',
    component: () => import('../components/canceldata/canceldata.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('../components/application/application.vue')
  },
  {
    path: '/prorecord',
    name: 'prorecord',
    component: () => import('../components/prove/prorecord.vue')
  },
  {
    path: '/provement',
    name: 'provement',
    component: () => import('../components/prove/provement.vue')
  },
  {
    path: '/myteamatt',
    name: 'myteamatt',
    component: () => import('../views/myteamatt.vue')
  },
  //收入证明申请
  {
    path: '/certincomedetail',
    name: 'certincomedetail',
    component: () => import('../views/cert/certincomedetail.vue')
  },
  //在职证明申请
  {
    path: '/certonjobdetail',
    name: 'certonjobdetail',
    component: () => import('../views/cert/certonjobdetail.vue')
  },
  //我的团队
  {
    path: '/myteam',
    name: 'myteam',
    component: () => import('../views/myteam/index.vue')
  },
  //我的团队-组织架构子部门
  {
    path: '/subdepartment',
    name: 'subdepartment',
    component: () => import('../views/myteam/subdepartment.vue')
  },
  //我的团队-组织架构子部门
  {
    path: '/teamemployees',
    name: 'teamemployees',
    component: () => import('../views/myteam/teamEmployees.vue')
  },
  //我的团队-组织架构二级子部门
  {
    path: '/sonteamemployees/:id',
    name: 'sonteamemployees',
    component: () => import('../views/myteam/sonTeamEmployees.vue')
  },
  //我的团队-团队绩效
  {
    path: '/teamperformance',
    name: 'teamperformance',
    component: () => import('../views/teamperformance.vue')
  },
  //我的团队-团队绩效详情
  {
    path: '/achievementsdel',
    name: 'achievementsdel',
    component: () => import('../views/achievementsdel.vue')
  },
  //团队分析
  {
    path: '/teamanalysis',
    name: 'teamanalysis',
    component: () => import('../views/teamanalysis.vue')
  },
  //团队奖惩信息
  {
    path: '/teamrp',
    name: 'teamrp',
    component: () => import('../views/teamrp.vue')
  },
  //团队薪酬
  {
    path: '/teampay',
    name: 'teampay',
    component: () => import('../views/teampay.vue')
  },
  //团队薪酬详情
  {
    path: '/teampaymessage',
    name: 'teampaymessage',
    component: () => import('../views/teampaymessage.vue')
  },
  //团队调薪
  {
    path: '/teamsalarychange',
    name: 'teamsalarychange',
    component: () => import('../views/teamsalarychange.vue')
  },
  //单点
  {
    path: '/soa-login',
    name: 'soa-login',
    component: () => import('../views/soa-login.vue')
  },
  // 电子签署文件列表
  {
    path: '/esignFileList',
    name: 'esignFileList',
    component: () => import('../views/esignFileList.vue')
  },
  // 合同文件
  {
    path: '/contractFile',
    name: 'contractFile',
    component: () => import('../views/contractFile.vue')
  },
  // 额外信息填写
  {
    path: '/extrainfo',
    name: 'extrainfo',
    component: () => import('../views/extrainfo.vue')
  },
  ...backDoor
];

const router = new VueRouter({
  // mode: 'history',
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes
});

router.beforeEach((to, from, next) => {
  const tokensign = sessionStorage.getItem('EMPLID');

  //next()

  if (to.path == '/') {
    if (!tokensign) {
      next({
        path: '/soa-login',
        query: {
          redirect: to.fullPath,
          code: ''
        }
      });

      // dd.ready(function () {
      //   dd.runtime.permission.requestAuthCode({
      //
      //     //正式
      //     corpId: "ding0ecca891926651c7f2c783f7214b6d69",
      //     onSuccess: function (result) {
      //       userIdDataApi({ code: result.code }).then(res => {
      //         if (res.resultCode == 200) {
      //           sessionStorage.setItem('EMPLID', res.emplid);
      //           next();
      //         }
      //       })
      //     },
      //     onFail: function (err) { }
      //   });
      // });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach(to => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   changTitle(to.meta.title);
  // }
  // let title = sessionStorage.getItem('EMPLID')
  // if (title) {
  //   let waterbox =
  //   store.state.basicinfo.NAME + sessionStorage.getItem('EMPLID')
  //   Watermark.set(waterbox)
  // } else {
  //   Watermark.out() // 清除水印
  // }
});

export default router;
